import React from 'react'
import classNames from 'classnames/bind'

import styles from './../skills-page.module.scss'

const cx = classNames.bind(styles)

export const SkillsList = ({displayFrontEnd, displayBackEnd, displayDesign, displayLeadership, displayMisc}) => {
    return (
        <>
            {displayFrontEnd.length > 0 &&
                <>
                    <h2 className={cx(["col-12", "animate__animated", "animate__fadeIn"])}>Frontend Development
                        Skills &amp; Technology</h2>

                    {/*Display a list for frontend development skills*/}
                    <ul className={cx(["row", "skill-list"])}>
                        {displayFrontEnd.map((skill, index) =>
                            <li className={cx(["col-12", "col-md-4", "animate__animated", "animate__fadeIn"])}
                                key={index}>{skill}</li>
                        )}
                    </ul>
                </>
            }

            {displayBackEnd.length > 0 &&
                <>
                    <h2 className={cx(["col-12", "animate__animated", "animate__fadeIn"])}>Backend Development
                        Skills &amp; Technology</h2>

                    {/*Display a list for backend development skills*/}
                    <ul className={cx(["row", "skill-list"])}>
                        {displayBackEnd.map((skill, index) =>
                            <li className={cx(["col-12", "col-md-4", "animate__animated", "animate__fadeIn"])}
                                key={index}>{skill}</li>
                        )}
                    </ul>
                </>
            }

            {displayDesign.length > 0 &&
                <>
                    <h2 className={cx(["col-12", "animate__animated", "animate__fadeIn"])}>Design
                        Skills &amp; Technology</h2>

                    {/*Display a list for design skills*/}
                    <ul className={cx(["row", "skill-list"])}>
                        {displayDesign.map((skill, index) =>
                            <li className={cx(["col-12", "col-md-4", "animate__animated", "animate__fadeIn"])}
                                key={index}>{skill}</li>
                        )}
                    </ul>
                </>
            }

            {displayLeadership.length > 0 &&
                <>
                    <h2 className={cx(["col-12", "animate__animated", "animate__fadeIn"])}>Leadership Skills</h2>

                    {/*Display a list for leadership skills*/}
                    <ul className={cx(["row", "skill-list"])}>
                        {displayLeadership.map((skill, index) =>
                            <li className={cx(["col-12", "col-md-4", "animate__animated", "animate__fadeIn"])}
                                key={index}>{skill}</li>
                        )}
                    </ul>
                </>
            }

            {displayMisc.length > 0 &&
                <>
                    <h2 className={cx(["col-12", "animate__animated", "animate__fadeIn"])}>Miscellaneous Skills</h2>

                    {/*Display a list for miscellaneous skills*/}
                    <ul className={cx(["row", "skill-list"])}>
                        {displayMisc.map((skill, index) =>
                            <li className={cx(["col-12", "col-md-4", "animate__animated", "animate__fadeIn"])}
                                key={index}>{skill}</li>
                        )}
                    </ul>
                </>
            }
        </>
    )
}